import * as actionTypes from "./ActionTypes";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
// import displayGlobalMessage from "Utils/DisplayGlobalMessage";
// import postData from "Utils/PostData";
// import patchData from "Utils/PatchData";
// import deleteData from "Utils/DeleteData";
import { store } from "Store";
// import GoogleLogin from "react-google-login";
// import { dispatch } from "d3";
import log from "loglevel";

// GETUSER
export function getUser() {
  const state = store.getState();
  return state.userInfo;
}

// AUTH
export const requestStarted = () => {
  return {
    type: actionTypes.REQUEST_STARTED,
  };
};

export const requestCompleted = (msg, error) => {

  return {
    type: actionTypes.REQUEST_COMPLETED,
    payload: { msg: msg, error: error },
  };
};

export const authSignUpSuccess = (response) => {
  return {
    type: actionTypes.AUTH_SIGNUP_SUCCESS,
    payload: {
      msg: response.data.msg,
    },
  };
};

export const authSuccess = (data) => {
  localStorage.setItem("token", `Token ${data.token}`);

  // log.log("data " + JSON.stringify(data))
  return {
    type: actionTypes.AUTH_SUCCESS,
    payload: { ...data, expirationDate: new Date(new Date().getTime() + constants.session_out_time * 1000).toString() }
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    payload: { error: error },
  };
};

export const authLogout = () => {
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

// FETCH FUNCTIONS
export const logout = () => {
  return async (dispatch) => {
    // log.log("Logging out...");
    // const user = getUser();

    try {
      const response = await httpService.post(
        // constants.base_url + "/api/auth/logout/"
        constants.base_url + "/accounts/logout/"
      );
      //log.log(response);
      if (response.status === 204 || response.status === 401) {
        //log.log("Logged out");
        // localStorage.removeItem("token");
        // localStorage.removeItem("expirationDate");
        dispatch(authLogout());
      }
      // dispatch(authLogout());
    } catch (err) {
      // log.log(err);
      if (err?.response?.status === 401) {
        // server restarted
        dispatch(authLogout());
      } else {
        dispatch(authFail(err));
      }
    }
  };
};

export const checkAuthTimeout = (expirationTime) => {
  return (_dispatch) => {
    // log.log("EXPIRATION_TIME", expirationTime);
    setTimeout(() => {
      // dispatch(authLogout());
      // alert("Your session timed out. Login again.");
      // location.href = "/";
    }, expirationTime * 1000);
  };
};

export const authSignUp = (email, first_name, last_name, password, roll_no = null) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    // log.log(email, first_name, last_name, password);
    try {
      const response = await httpService.post(
        constants.base_url + "/accounts/api/register/",
        {
          email: email,
          first_name: first_name,
          last_name: last_name,
          password: password,
          roll_no: constants.enableSignupRollNo ? roll_no : null,
        }
      );
      // log.log(response);
      // log.log({authSignUpResponse: response});
      if (response.data && response.data.error) {
        dispatch(authFail(response.data.error));
      } else {
        dispatch(authSignUpSuccess(response));
      }
      // return response;
    } catch (err) {
      // log.log(err);
      log.log({ authSignUpError: err });
      // dispatch(authFail(err));
      if (err.response?.data?.error) {
        dispatch(authFail(err.response.data.error));
      } else {
        dispatch(authFail("Some error occurred"));
      }
    }
  };
};


/*
Google OAuth tokenId request to backend for verification 
Backend verifies tokenId, logs in a user is email id exits in the database else creates a new user.
*/
export const googleLogin = (tokenId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await httpService.post("/accounts/loginapi/", {
        google_auth_token: tokenId
      });
      // log.log("Backend Response to Google Login");
      // log.log(response);

      if (response.status === 200) {
        dispatch(authSuccess(response.data));
      } else if (response.status === 201) {
        // log.log(response.data.error);
        const error = response.data.error;
        dispatch(authFail(error));
      } else {
        const error = "Some unexpected problem happened";
        dispatch(authFail(error));
      }
    } catch (err) {
      // log.log(err);
      dispatch(authFail(err));
    }
  };

};

// Add this method to your httpService exports

export const authLogin = (username, password, csrfToken) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    // log.log(username);

    try {
      let config = {
        headers: {
          // 'X-CSRFToken': csrfToken,
          // 'Authorization': null,
        }
      }
      if (!csrfToken) {
        config = null;
      }
      const response = await httpService.postWithoutAuth("/accounts/loginapi/", {
        username: username.toLowerCase(),
        password: password,
      });
      log.log({response})
      // log.log("HEEEEEEEEEEELLLLOOO");
      // log.log(response);
      // alert(username);
      // return response;

      if (response.status === 200) {
        dispatch(authSuccess(response.data));
      } else if (response.status === 201) {
        let error = "";
        if (response.data?.error) {
          error = response.data.error;
        }
        log.log(response.data.error);
        dispatch(authFail(error));
        // requestCompleted(null, error);
      } else {
        let error = "Some unexpected problem happened";
        if (response.data?.error) {
          error = response.data.error;
        }
        dispatch(authFail(error));
        // requestCompleted(null, error);
      }
      return response;
    } catch (err) {
      log.log(err);
      log.log(err?.response?.data?.includes('Forbidden 403'))
      if (err?.response?.data?.includes?.('Forbidden 403')) {
        dispatch(authFail("User is not registered."));
      } else {
        dispatch(authFail(err));
      }
      return err?.response;
    }
  };
};

export const IITBSSOLogin = () => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await httpService.get("/accounts/ssoAPI/", {
      });
      // log.log("HEEEEEEEEEEELLLLOOO");
      // log.log(response.data.url);

      window.location.href = response.data.url;
      // const responseFromSSO = await httpService.get(response.data.url, {
      // });
      let username = "";
      // log.log(responseFromSSO);
      alert(username);
      if (response.status === 200) {
        dispatch(authSuccess(response.data));
      } else if (response.status === 201) {
        // log.log(response.data.error);
        const error = response.data.error;
        dispatch(authFail(error));
        // requestCompleted(null, error);
      } else {
        let error = "Some unexpected problem happened";
        if (response?.data?.error) {
          error = response.data.error;
        }
        dispatch(authFail(error));
        // requestCompleted(null, error);
      }
    } catch (err) {
      // log.log(err);
      dispatch(authFail(err));
    }
  };
};

export const authCheckState = (token, username, expirationDate) => {
  return (dispatch) => {
    // log.log("Token", token);
    if (token === "undefined" || token === null) {
      dispatch(authLogout());
    } else {
      // log.log(expirationDate, new Date());
      if (new Date(expirationDate) <= new Date()) {
        dispatch(authLogout());
      } else {
        dispatch(authSuccess({ username: username, token: token }));
        dispatch(
          checkAuthTimeout(
            (new Date(expirationDate).getTime() - new Date().getTime()) / 1000
          )
        );
      }
    }
  };
};

export const getUserPriviliges = async () => {
  try {
    const response = await httpService.post("user/api/profile/is_instructor/", null, {
      headers: {
        "Authorization": localStorage.getItem("token")
      }
    });
    log.log({ getUserPriviligesResponse: response });
    return response.data;
  } catch (err) {
    log.log({ "get user priviliges error ": err });
  }
}

export const changeUserMode = () => {
  return async (dispatch) => {
    // log.log("Logging out...");
    // const user = getUser();

    try {
      const response = await httpService.post(
        constants.base_url + "/api/auth/logout/"
      );
      // log.log(response);
      if (response.status === 204) {
        // log.log("Logged out");
        // localStorage.removeItem("token");
        // localStorage.removeItem("expirationDate");
        dispatch(authLogout());
      }
    } catch (err) {
      // log.log(err);
      dispatch(authFail(err));
    }
  };
};

export const modeSwitch = (mode, _token) => {
  return async (dispatch) => {
    try {
      dispatch(userModeChange(mode));
    } catch (err) {
      log.log(err);
    }
  };
};

export const userModeChange = (mode) => {
  return {
    type: actionTypes.MODE_CHANGE,
    payload: { mode: mode },
  };
};

export const updateUserIsInstructor = (is_instructor) => {
  return async (dispatch) => {
    try {
      dispatch(isUserInstructor(is_instructor));
    } catch (err) {
      log.log(err);
    }
  };
};

export const isUserInstructor = (is_instructor) => {
  return {
    type: actionTypes.IS_INSTRUCTOR,
    payload: { is_instructor: is_instructor },
  };
};


//following method is not a correct method
// it was added to remove the module not found error
export const modeRoutes = (mode, _token) => {
  return async (dispatch) => {
    try {
      dispatch(userModeChange(mode));
    } catch (err) {
      log.log(err);
    }
  };
}
